export const FETCH_ORDERS = 'listOrders/FETCH';
export const FETCH_ORDERS_SUCCESS = 'listOrders/FETCH_SUCESS';
export const FETCH_ORDERS_FAIL = 'listOrders/FETCH_FAIL';

const initialState = {
  orders: null,
  limit: 0,
  offset: 0,
  total: 0,
  isLoading: false,
  requestCompleted: false,
};

const initialAction = {};

const OrdersListReducer = (state = initialState, action = initialAction) => {
  switch (action.type) {
    case FETCH_ORDERS:
      return {
        ...state,
        isLoading: true,
        requestCompleted: false,
      };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        orders: action.payload.orders,
        limit: action.payload.limit,
        offset: action.payload.offset,
        total: action.payload.total,
      };
    case FETCH_ORDERS_FAIL:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        error: action.payload.error,
      };
    default:
      return { ...state };
  }
}

export default OrdersListReducer;
